import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/settings_/workflows/')({
  beforeLoad: () => {
    // Workflows were promoted to a top-level nav entry. The definitions list
    // now lives under the global /workflows control tower; redirect any old
    // links here to keep them working.
    throw redirect({ to: '/workflows', replace: true })
  },
})
